import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { grantConsent, denyConsent, getConsentChoice } from '../utils/metaPixel'

/**
 * Cookie consent state.
 *
 * - 'undecided': user has not made a choice; banner should be visible.
 * - 'granted': user accepted marketing/analytics cookies.
 * - 'denied': user rejected them.
 *
 * The Meta Pixel base code is already loaded by index.html; this store gates
 * all additional custom events and grants/revokes consent with fbq when the
 * user makes a choice.
 */
export const useConsentStore = create(
  persist(
    (set) => ({
      consent: 'undecided',

      initialize() {
        const choice = getConsentChoice()
        if (choice === 'granted') {
          grantConsent()
          set({ consent: 'granted' })
        } else if (choice === 'denied') {
          denyConsent()
          set({ consent: 'denied' })
        } else {
          set({ consent: 'undecided' })
        }
      },

      accept() {
        grantConsent()
        set({ consent: 'granted' })
      },

      reject() {
        denyConsent()
        set({ consent: 'denied' })
      },

      reset() {
        set({ consent: 'undecided' })
      },
    }),
    {
      name: 'swiaty-consent',
      partialize: (state) => ({ consent: state.consent }),
    }
  )
)
